import PoliciesPage from './policies-page'
export default PoliciesPage
